export const DESCRIPTIONS_BY_TYPE = {
  electronicAndElectronicVoucher: (
    <ul data-testid="electronicAndElectronicVoucher">
      <li>This eGift card can be redeemed online.</li>
      <li>This printable voucher can be redeemed on location.</li>
      <li>
        Most eGift cards and printable vouchers are delivered to your GCX
        account instantly, but please allow up to 24 hours.
      </li>
    </ul>
  ),
  electronic: (
    <ul data-testid="electronic">
      <li>This eGift card can be redeemed online only.</li>
      <li>
        Most eGift cards are delivered to your GCX account instantly, but please
        allow up to 24 hours.
      </li>
    </ul>
  ),
  electronicVoucher: (
    <ul data-testid="electronicVoucher">
      <li>This printable voucher can be redeemed on location.</li>
      <li>
        Most printable vouchers are delivered to your GCX account instantly, but
        please allow up to 24 hours.
      </li>
    </ul>
  ),
  lettuce: (
    <ul data-testid="lettuce">
      <li>This printable voucher can be redeemed on location.</li>
      <li>
        Most eGift cards and printable vouchers are delivered to your GCX
        account instantly, but please allow up to 24 hours.
      </li>
    </ul>
  )
};
